"use strict";

import Vue from "vue";
import axios from "axios";
import router from "../router"
import store from "../store"
import messageBox from "../components/Global/CMessage/message";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  timeout: 80 * 1000 // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    if (config.url.indexOf("/app") === 0) {
      config.baseURL = process.env.VUE_APP_API_URL;
      config.headers.Authorization = localStorage.getItem("api_token");
      // localStorage.getItem("token")
    } else if (config.url.includes("/ibenterprise")) {
      // 公开接口直接使用 env 中的地址
      config.baseURL = process.env.VUE_APP_PUBLIC_API_URL;
    } else if(config.url.includes("/monitor") || config.url.includes("api/recording")){
      // 录屏接口使用 monitor 的地址
      config.baseURL = process.env.VUE_APP_MONITOR_API_URL;
    }
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    // 只有 /app/api 开头的接口才检查 code
    if (response.config.url.indexOf("/app/api") > 0) {
      // api 请求 code 不是 200 的都是失败，走 catch 捕捉
      if (response.data.code !== 200) {
        const message = response.data.message || "操作失败";
        if(response.data.code ==4104){
          messageBox.error(response.data.message)
          setTimeout(() => {
            store.dispatch("logout").then(() => {
              router.replace({ name: "home" });
              router.go(0)
            });
          }, 1000);
        }
        throw Error(message);
      }
    }
    return response.data;
  },
  function(error) {
    console.log("request error:", error.status);
    const res = JSON.parse(JSON.stringify(error)).response
    if(res.status == 4101||res.status ==4104){
      messageBox.error(response.data.message)
      setTimeout(() => {
        store.dispatch("logout").then(() => {
          router.replace({ name: "home" });
          router.go(0)
        });
      }, 1000);
    }
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue) {
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default _axios;
